<template>
    <div>
        <span class="title-text grey--text"> <slot name="title"/></span>
        <v-menu offset-y>
            <template v-slot:activator="{ props }">
            <v-card v-bind="props" elevation="0">
            <div class="d-flex mb-0" >
                <v-chip-group style="height:40px" class="chip-array">
                    <v-chip v-for="tag in tags" 
                        @click:close="deleteTag(tag)"
                        :key="tag.value"
                        size="x-small"
                        label
                        closable
                        close-icon="close"
                        class="px-2"
                        style="font-size:10px;font-weight:bold"
                    >
                    {{ tag.title }}
                    </v-chip>
                </v-chip-group>
        
                <v-icon color="grey" small>arrow_left</v-icon>
            </div>
            <v-divider/>
            </v-card>
            </template>
        
                <v-list v-model:selected="model" :select-strategy="allow_multiple ? 'leaf' : 'single-leaf'" style="max-height: 240px" class="overflow-y-auto">
                  <template v-if="items.length !== 0">
                    <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        dense
                        @click="onChange"
                        :value="item.value"
                        active-class="text-gray"
                    >
                      <v-list-item-title>
                       {{item.title}}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <v-list-item> Žádná dostupná data </v-list-item>
                  </template>
                </v-list>
        </v-menu>
        
    </div>


</template>

<script>

import {nextTick} from "vue";

export default {

    name: "MobileFiltering",
    props: {
        items : {
            type: Array,
            required: false
        },
        allow_multiple: {
            type: Boolean,
            required: false,
            default: false
        },
        selected: {
          type: String,
          required: false
        }
    },


  computed: {
      tags(){
        const item = this.items.find(item => item.value === this.selected)
        return item ? [item] : []
      }
  },
  data: (props) => {
      return {
        model: props.selected ? [props.selected] : [],
      }
    },
  watch: {
      'selected'(newValue) {
        this.model = newValue ? [newValue] : []
      },
  },
    methods : {
        onChange(){
          nextTick(()=>{
            if(this.allow_multiple){
              const newKey = this.items[this.model[this.model.length - 1]].title
              if (!this.tags.includes(newKey)) this.tags.push(newKey)
            } else {
              this.$emit('update:model', this.model[0])
            }
           })
        },
        deleteTag(tag){
            this.removeFromSelected(tag)
            this.$emit('update:model', null)
        },
        removeFromSelected(tag){
          this.model = this.model.filter(i => i !== tag.value)
        }
    },
};
</script>

<style scoped>

.title-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 9px;
    font-weight: bold;
}
.select {
    font-size: 12px;
    z-index: 3;
}
#v-list{
  height:200px;/* or any height you want */
  overflow-y:auto
}
.chip-array {
    width: calc(100% - 16px);
}


</style>